import React from 'react';
import Block from './Block';
import EyeTracker from './EyeTracker';
import { CELL_SIZE, CELL_GAP } from '../utils/constants';

function PrisonerBlock({ block, onMove, getMoveRange, isComplete }) {
  const width = block.width * CELL_SIZE + (block.width - 1) * CELL_GAP;
  const height = block.height * CELL_SIZE + (block.height - 1) * CELL_GAP;
  
  return (
    <Block
      block={block}
      onMove={onMove}
      getMoveRange={getMoveRange}
      isComplete={isComplete}
    >
      <EyeTracker width={width} height={height} />
    </Block>
  );
}

export default PrisonerBlock;
